import { useState } from "react";

import { useChangeEffect } from "./useChangeEffect";

export function useTransitionState(
  isIn: boolean,
  transitionDurationMs: number,
) {
  const [state, setState] = useState<
    "enter-active" | "entered" | "exited" | "exit-active"
  >(isIn ? "entered" : "exited");

  useChangeEffect(() => {
    let timeoutId: number;

    if (isIn) {
      setState("enter-active");

      timeoutId = window.setTimeout(() => {
        setState("entered");
      }, transitionDurationMs);
    } else {
      setState("exit-active");

      timeoutId = window.setTimeout(() => {
        setState("exited");
      }, transitionDurationMs);
    }

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isIn]);

  return state;
}
